<div
  class="w-full p-2 px-3 border border-zinc-200 bg-white rounded-md focus-within:-500"
  [ngClass]="class()"
>
  <input
    #input
    (input)="onInput($event)"
    [name]="formControlName()"
    [placeholder]="placeholder()"
    [maxLength]="maxLength()"
    [readOnly]="readonly()"
    [inputMode]="inputMode()"
    [disabled]="disabled()"
    class="w-full outline-none placeholder:text-zinc-400"
  />
</div>
